import type { IconSvgObject } from './types';

const FolderZipIcon: IconSvgObject = [
  ["path", { d: "M8 6.99446H12.0179M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V8.99446C22 7.88989 21.1046 6.99446 20 6.99446H18.5M12.0179 6.99446H15V10.9972M15 15H13M15 15H17M15 15V10.9972M15 10.9972H13M15 10.9972H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default FolderZipIcon;
